import { MENTION_TYPE } from "@/constants";
import { MentionV4 } from "@/types/MentionCard";

export function categorizeMentionsByContext(mentions: MentionV4[]) {
  const titleMention = mentions.find(
    (mention) => mention.context === MENTION_TYPE.EPISODE_NAME
  );

  const otherMentions = titleMention
    ? mentions.filter((mention) => mention.id !== titleMention?.id)
    : mentions;

  return {
    titleMention,
    otherMentions,
  };
}

export function getDescriptionMention(mentions: MentionV4[]) {
  return mentions.find(
    (mention) => mention.context === MENTION_TYPE.EPISODE_DESCRIPTION
  );
}

export function getTitleAndDescriptionMentions(mentions: MentionV4[]) {
  let titleMention: MentionV4 | undefined;
  let descriptionMention: MentionV4 | undefined;

  mentions?.forEach((mention) => {
    if (mention.context === MENTION_TYPE.EPISODE_NAME) {
      titleMention = mention;
    }

    if (mention.context === MENTION_TYPE.EPISODE_DESCRIPTION) {
      descriptionMention = mention;
    }
  });

  const otherMentions = mentions.filter(
    (mention) =>
      mention.id !== titleMention?.id && mention.id !== descriptionMention?.id
  );

  return {
    otherMentions,
    titleMention,
    descriptionMention,
  };
}
